import {TargetGroup} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/target_group.types';
import {useSelectedTargetGroup} from '../../../shared-deprecated/useSelectedTargetGroup';
import {useSelectedDiscount} from './useSelectedDiscount';

export const useSelectedDiscountUrl = (): null | {url?: string} => {
  const {targetGroup} = useSelectedTargetGroup();
  const selectedDiscount = useSelectedDiscount();

  if (!selectedDiscount) {
    return null;
  }
  if (targetGroup === TargetGroup.MALE) {
    return {
      url: selectedDiscount.maleTopBanner.path,
    };
  } else {
    return {
      url: selectedDiscount.femaleTopBanner.path,
    };
  }
};
